import * as Yup from 'yup'
import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile'
import { BRIEF_TYPE } from '../index'

Yup.addMethod(Yup.string, 'phoneNumber', function(formatMessage) {
  return this.test({
    name: 'phoneNumber',
    exclusive: true,
    message: formatMessage({ id: 'Brief.schema.phone.inValid' }),
    test: value => {
      if (!value) return true

      try {
        return parsePhoneNumberFromString(value, 'RU').isValid()
      } catch (e) {
        return false
      }
    }
  })
})

export const initialValues = () => ({
  source: 'services',
  platform: BRIEF_TYPE.SOCIAL,
  goods: '',
  companyName: '',
  siteUrl: '',
  companyPolicy: '',
  showRegions: '',
  comment: '',
  firstname: '',
  email: '',
  phone: '',
  dataProcessingPermission: false
})

const schemaValidation = (values, formatMessage) => ({
  goods: Yup.string().required(formatMessage({ id: 'Brief.schema.goods.required' })),
  showRegions: Yup.string().required(formatMessage({ id: 'Brief.schema.showRegions.required' })),
  companyName: Yup.string().required(formatMessage({ id: 'Brief.schema.company.required' })),
  siteUrl: Yup.string().required(formatMessage({ id: 'Brief.schema.companyFacebook.required' })),
  companyPolicy: Yup.string(),
  comment: Yup.string(),
  firstname: Yup.string()
    .required(formatMessage({ id: 'Brief.schema.firstName.required' }))
    .max(100, formatMessage({ id: 'Brief.schema.firstName.max' }))
    .matches(/^[а-яёa-z\s\-]+$/iu, formatMessage({ id: 'Brief.schema.firstName.inValid' })), // eslint-disable-line
  email: Yup.string()
    .email(formatMessage({ id: 'Brief.schema.email.inValid' }))
    .max(100, formatMessage({ id: 'Brief.schema.email.max' }))
    .required(formatMessage({ id: 'Brief.schema.email.required' })),
  phone: Yup.string()
    .required(formatMessage({ id: 'Brief.schema.phone.required' }))
    .phoneNumber(formatMessage),
  dataProcessingPermission: Yup.boolean()
    .oneOf([true], formatMessage({ id: 'Brief.schema.agreement.required' }))
    .required(formatMessage({ id: 'Brief.schema.agreement.required' }))
})

export const briefSchema = formatMessage =>
  Yup.lazy(values => Yup.object().shape(schemaValidation(values, formatMessage)))
